export default __webpack_public_path__ + "static/accents-border-token-light-1e1a2f9e7eb3e864e1c1061bd01213c3.png";